import {Component, inject, input} from '@angular/core';
import {MatDialog} from "@angular/material/dialog";
import {ProductCardData} from "../../../types/product-card-data.types";
import {defaultProductCardData} from "../../../configs/default-product-card-data";
import {PcRatingModalComponent} from "../../modals/pc-rating-modal/pc-rating-modal.component";
import {FormatNumberPipe} from "../../../../../../shared/pipes/format-number.pipe";
import {MatButton} from "@angular/material/button";

@Component({
  selector: 'app-pc-rating',
  standalone: true,
  imports: [
    FormatNumberPipe,
    MatButton
  ],
  templateUrl: './pc-rating.component.html',
  styleUrl: './pc-rating.component.scss'
})
export class PcRatingComponent {
  productCardId = input<number>(0);
  productCardData = input<ProductCardData>(defaultProductCardData);

  private dialog: MatDialog = inject(MatDialog);

  public async handleRating() {
    this.dialog.open(PcRatingModalComponent, {
      data: { productCardId: this.productCardId() },
    })
  }
}
